const ankle_questions = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].RadioButtonList[3]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].RadioButtonList[2]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "maxLength": 2000,
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].IdentifyEvidence[0]",
      "textanswer":""
   },   
   {
      "question":"Perform active range of motion and provide the ROM values",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Right Plantar Flexion",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].ROM4b1a[0]",
            "defaultVal":"45",
            "values":["45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"45"
         },
         {
            "main":"Right Dorsiflexion",
            "subMain":"Normal Endpoint is 20 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].ROM3b1a[0]",
            "defaultVal":"20",
            "values":["20", "15", "10", "5"],
            "answer":"20"
         },
         {
            "main":"Left Plantar Flexion",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].ROM4b[0]",
            "defaultVal":"45",
            "values":["45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"45"
         },
         {
            "main":"Left Dorsiflexion",
            "subMain":"Normal Endpoint is 20 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].ROM3b[0]",
            "defaultVal":"20",
            "values":["20", "15", "10", "5"],
            "answer":"20"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain? ",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Right Plantar Flexion",
            "dbqName":"form1[0].#subform[4].Rightdorsipain[0]",
            "answer":""
         },
         {
            "main":"Left Plantar Flexion",
            "dbqName":"form1[0].#subform[4].LeftDorsiflexionPain[0]",
            "answer":""
         },
         {
            "main":"Right Dorsiflexion",
            "dbqName":"form1[0].#subform[4].RightPlantarPain[0]",
            "answer":""
         },
         {
            "main":"Left Dorsiflexion",
            "dbqName":"form1[0].#subform[4].LeftPlantarflexionPain[0]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Right Ankle",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "small": true,
      "cols": 3,
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[4].Rightweightb[0],form1[0].#subform[4].YesNo12u[1]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[4].Rightnonweightb[0],form1[0].#subform[4].YesNo12u[1]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[4].Rightactive[0],form1[0].#subform[4].YesNo12u[1]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[4].Rightpassivem[0],form1[0].#subform[4].YesNo12u[1]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[4].RightRest[0],form1[0].#subform[4].YesNo12u[1]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[4].RightNoloss[0],form1[0].#subform[4].YesNo12u[1]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[4].ExplainWhy[12]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[4].Rightloss[0],form1[0].#subform[4].YesNo12u[1]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[4].YesNo12u[0]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Left Ankle",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "small": true,
      "cols": 3,
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[4].Leftweightb[0],form1[0].#subform[4].YesNo12v[1]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[4].LeftNonweight[0],form1[0].#subform[4].YesNo12v[1]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[4].LeftActive[0],form1[0].#subform[4].YesNo12v[1]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[4].Leftpassive[0],form1[0].#subform[4].YesNo12v[1]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[4].LeftNonrest[0],form1[0].#subform[4].YesNo12v[1]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[4].LeftNoloss[0],form1[0].#subform[4].YesNo12v[1]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[4].ExplainWhy[13]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[4].LefLoss[0],form1[0].#subform[4].YesNo12v[1]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[4].YesNo12v[0]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Does ##name## report or have a history of instability of the ankle?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "2D"
      },
      "maxLength": 728,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[2].YesNo2D3[0]",
      "dbqName_no":"form1[0].#subform[2].YesNo2D3[1]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder":"Please Describe the history of instability of the ankle",
      "textdbqName":"form1[0].#subform[2].Describe2[1]",
      "textanswer":""
   },
   {
      "question":"Is there objective evidence of crepitus?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Ankle",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[4].YesNo12[1]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[4].YesNo12[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Ankle",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[4].YesNoCL1[1]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[4].YesNoCL1[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },   
   {
      "question":"For the ##redHeading##, Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue?",
      "redHeading": "Right Ankle",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "maxLength": 220,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[4].YesNo10Pn[1]",
      "dbqName_no":"form1[0].#subform[4].YesNo10Pn[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder":"Please Describe the location, severity, and relationship to the Right Ankle condition",
      "textdbqName":"form1[0].#subform[4].ExplainWhy[14]",
      "textanswer":""
   },
   {
      "question":"For the ##redHeading##, Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue?",
      "redHeading": "Left Ankle",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "maxLength": 220,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[4].YesNo101kt[1]",
      "dbqName_no":"form1[0].#subform[4].YesNo101kt[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder":"Please Describe the location, severity, and relationship to the Left Ankle condition",
      "textdbqName":"form1[0].#subform[4].ExplainWhy[15]",
      "textanswer":""
   },


   {
      "question":"Anterior Drawer Test",
      "sub":"Is there absence of firm end point with asymmetric or excessive motion?",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "JOINT STABILITY",
         number: "6A"
      },
      "questions":[
         {
            "label":"Right Ankle",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "No",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[8].Right_AnteriorTest[2]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[8].Right_AnteriorTest[1]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Ankle",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "No",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[8].Left_AnteriorTest[0]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[8].Left_AnteriorTest[1]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Talar Tilt Test",
      "sub":"Is there asymmetric or excessive motion?",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "JOINT STABILITY",
         number: "6A"
      },
      "questions":[
         {
            "label":"Right Ankle",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "No",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[8].Right_TalarTest[1]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[8].Right_TalarTest[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Ankle",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "No",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[8].Left_TalarTest[0]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[8].Left_TalarTest[1]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Shin Splints (medial tibial stress syndrome - MTSS) for the ##redHeading##,",
      "redHeading": "Right Ankle",
      "sub":"Indicate all treatment and symptoms below",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "partial": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "9",
         title: "ADDITIONAL COMMENTS",
         number: "7A"
      },
      "questions":[
         {
            "main":"Treatment for less than 12 Consecutive months – (Rest/ Ice/ Compression/ Elevation)",
            "dbqName":"form1[0].#subform[8].RTshin2[0],form1[0].#subform[8].Condition1[0],form1[0].#subform[8].YesNo30[0]",
            "answer":""
         },
         {
            "main":"Unresponsive to shoe orthotics or other conservative treatment",
            "dbqName":"form1[0].#subform[8].RTshin3[0],form1[0].#subform[8].Condition1[0],form1[0].#subform[8].YesNo30[0]",
            "answer":""
         },
         {
            "main":"Requiring treatment for 12 consecutive months or more",
            "dbqName":"form1[0].#subform[8].RTshin4[0],form1[0].#subform[8].Condition1[0],form1[0].#subform[8].YesNo30[0]",
            "answer":""
         },
         {
            "main":"Responsive to surgery",
            "dbqName":"form1[0].#subform[8].RTshin1[0],form1[0].#subform[8].Condition1[0],form1[0].#subform[8].YesNo30[0]",
            "answer":""
         },
         {
            "main":"Unresponsive to surgery",
            "dbqName":"form1[0].#subform[8].RTshin5[0],form1[0].#subform[8].Condition1[0],form1[0].#subform[8].YesNo30[0]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[8].YesNo30[1]",
            "answer":""
         } 
      ],
      "answer":""
   },
   {
      "question":"Shin Splints (medial tibial stress syndrome - MTSS) for the ##redHeading##,",
      "redHeading": "Left Ankle",
      "sub":"Indicate all treatment and symptoms below",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "partial": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "9",
         title: "ADDITIONAL COMMENTS",
         number: "7A"
      },
      "questions":[
         {
            "main":"Treatment for less than 12 Consecutive months – (Rest/ Ice/ Compression/ Elevation)",
            "dbqName":"form1[0].#subform[8].lTshin2[0],form1[0].#subform[8].Condition17a[0],form1[0].#subform[8].YesNo307a[0]",
            "answer":""
         },
         {
            "main":"Unresponsive to shoe orthotics or other conservative treatment",
            "dbqName":"form1[0].#subform[8].lTshin3[0],form1[0].#subform[8].Condition17a[0],form1[0].#subform[8].YesNo307a[0]",
            "answer":""
         },
         {
            "main":"Requiring treatment for 12 consecutive months or more",
            "dbqName":"form1[0].#subform[8].lTshin4[0],form1[0].#subform[8].Condition17a[0],form1[0].#subform[8].YesNo307a[0]",
            "answer":""
         },
         {
            "main":"Responsive to surgery",
            "dbqName":"form1[0].#subform[8].lTshin1[0],form1[0].#subform[8].Condition17a[0],form1[0].#subform[8].YesNo307a[0]",
            "answer":""
         },
         {
            "main":"Unresponsive to surgery",
            "dbqName":"form1[0].#subform[8].lTshin5[0],form1[0].#subform[8].Condition17a[0],form1[0].#subform[8].YesNo307a[0]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[8].YesNo307a[1]",
            "answer":""
         }
      ],
      "answer":""
   },

   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Right ankle",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "10",
         title: "SURGICAL PROCEDURES",
         number: "8A"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[9].NosurgeryRight[0]",
                  "partialField": true,
                  "answer":"",
               },  
               {
                  "main":"Total ankle joint replacement",
                  "dbqName":"form1[0].#subform[9].TotalankleRight[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[9].DateOfSurgery[1]",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[9].ResidualsRight1[0]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Intermediate degrees of residual weakness, pain, or limitation of motion",
                        "dbqName":"form1[0].#subform[9].ResidualsRight2[0]",
                        "colWidth": 9,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[9].ResidualsRight4[0]",
                        "colWidth": 3,
                        "subItemLinked": true,
                        "answer":""
                     },
                     {
                        "main":"Chronic residuals consisting of severe painful motion or weakness",
                        "dbqName":"form1[0].#subform[9].ResidualsRight3[0]",
                        "colWidth": 9,
                        "answer":""
                     }
                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[9].OtherDescribe[2]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic or other ankle surgery",
                  "dbqName":"form1[0].#subform[9].LeftSide[3]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[9].TypeofSurgery[1]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[9].DateOfSurgery[3]",
               },
               {
                  "main":"Residuals of arthroscopic or other ankle surgery",
                  "dbqName":"form1[0].#subform[9].LeftSide[2]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[9].OtherDescribe[4]",
                  "placeholder1":"Type of surgery",
               }, 
                                     
            ],
            "answer":""
   },

   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Left ankle",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "10",
         title: "SURGICAL PROCEDURES",
         number: "8A"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[9].NosurgeryLeft[0]",
                  "partialField": true,
                  "answer":"",
               },  
               {
                  "main":"Total ankle joint replacement",
                  "dbqName":"form1[0].#subform[9].TotalankleLeft[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[9].DateOfSurgery[0]",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[9].ResidualsLeft1[0]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Intermediate degrees of residual weakness, pain, or limitation of motion",
                        "dbqName":"form1[0].#subform[9].ResidualsLeft2[0]",
                        "colWidth": 9,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[9].ResidualsLeft4[0]",
                        "colWidth": 3,
                        "subItemLinked": true,
                        "answer":""
                     },
                     {
                        "main":"Chronic residuals consisting of severe painful motion or weakness",
                        "dbqName":"form1[0].#subform[9].ResidualsLeft3[0]",
                        "colWidth": 9,
                        "answer":""
                     }
                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[9].OtherDescribe[1]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic or other ankle surgery",
                  "dbqName":"form1[0].#subform[9].LeftSide[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[9].TypeofSurgery[0]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[9].DateOfSurgery[2]"
               },
               {
                  "main":"Residuals of arthroscopic or other ankle surgery",
                  "dbqName":"form1[0].#subform[9].LeftSide[1]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[9].OtherDescribe[3]",
                  "placeholder1":"Type of surgery",
               },                       
            ],
            "answer":""
   },
   
   {
      "question":"Additional Comments",
      "optional": true,
      "sub":"",
      "show": true,
      "section": {
         page: "13",
         title: "REMARKS",
         number: "14A"
      },
      "type":"textarea",
      "maxLength": 1800,
      "options":[],
      "dbqName":"form1[0].#subform[12].Comments[2]",
      "answer":""
   }
]

export default ankle_questions;